import React, { CSSProperties } from "react";

export default function IconLED(props: {
	className?: string;
	style?: CSSProperties;
	color?: string;
	size?: number;
}) {
	return (
		<svg
			className={props.className}
			style={props.style}
			xmlns="http://www.w3.org/2000/svg"
			width={props.size ?? 24}
			height={props.size ?? 24}
			viewBox="0 0 24 24"
		>
			<path
				d="M12 19a1 1 0 0 1 1 .9V21a1 1 0 0 1-2 .1V20a1 1 0 0 1 1-1m6.3-2h.1l.7.7a1 1 0 0 1-1.3 1.5h-.1l-.7-.8a1 1 0 0 1 1.2-1.6zM7 17a1 1 0 0 1 0 1.3v.1l-.7.7a1 1 0 0 1-1.5-1.3v-.1l.8-.7A1 1 0 0 1 7 17m-3-6a1 1 0 0 1 .1 2H3a1 1 0 0 1-.1-2H4m17 0a1 1 0 0 1 .1 2H20a1 1 0 0 1-.1-2H21M6.2 4.8h.1l.7.8A1 1 0 0 1 5.7 7h-.1l-.7-.8A1 1 0 0 1 6 4.7zm13 0a1 1 0 0 1 0 1.4v.1l-.8.7A1 1 0 0 1 17 5.7v-.1l.8-.7a1 1 0 0 1 1.4 0M12 2a1 1 0 0 1 1 .9V4a1 1 0 0 1-2 .1V3a1 1 0 0 1 1-1m0 5a5 5 0 1 1-5 5.2v-.4A5 5 0 0 1 12 7"
				fill={props.color ?? "black"}
			/>
		</svg>
	);
}
